(function () {
  function initSeoDescription(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.collection-description');

    containers.forEach(function (desc) {
      if (desc.dataset.seoDescInited === '1') return;
      desc.dataset.seoDescInited = '1';

      var readMore = desc.querySelector('.read-more');
      var readLess = desc.querySelector('.read-less');
      var content = desc.querySelector('.seo-description__content');
      var textEl = desc.querySelector('.seo-description__text');

      if (!readMore || !readLess || !content || !textEl) return;

      // Default to collapsed state: show title + 3 lines of text
      content.classList.add('is-collapsed');
      readLess.style.display = 'none';

      // Only show the Read More button when content actually overflows
      if (textEl.scrollHeight > textEl.clientHeight + 1) {
        readMore.style.display = 'inline-block';
      } else {
        readMore.style.display = 'none';
      }

      readMore.addEventListener('click', function () {
        content.classList.remove('is-collapsed');
        readMore.style.display = 'none';
        readLess.style.display = 'inline-block';
      });

      readLess.addEventListener('click', function () {
        content.classList.add('is-collapsed');
        readLess.style.display = 'none';
        if (textEl.scrollHeight > textEl.clientHeight + 1) {
          readMore.style.display = 'inline-block';
        } else {
          readMore.style.display = 'none';
        }
      });
    });
  }

  // Initialize on first load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSeoDescription(); });
  } else {
    initSeoDescription();
  }

  // Re-initialize when the section is loaded/changed in the Theme Editor
  document.addEventListener('shopify:section:load', function (evt) {
    var container = evt.target || evt.currentTarget;
    initSeoDescription(container);
  });
})();
